import { BASE_PROJECT } from '@/constant/project'
import { router } from '@/main'
import { confirm } from '@/utils/dialog'
import {
  TIMEOUT,
  interceptors,
} from './httpConfig'
import { danger } from './notify'

const axios = require('@/assets/lib/axios')

const http = axios.create({
  baseURL: window.location.origin, // 默认是所属服务器域名
  timeout: TIMEOUT,
  withCredentials: true,
})

const handleResponseDataWithErrorHandler = interceptors.response.handleResponseData.bind(undefined, ({ err }) => alert(err))

http.interceptors.response.use(handleResponseDataWithErrorHandler, (result) => {
  if (result?.cancel) {
    return Promise.resolve(result)
  }

  const { status } = result?.response || {}

  if (status === 503) {
    confirm({
      message: '提示请在微信客户端打开链接',
      showCancelButton: false,
    })
  }

  if (status === 506) {
    danger('操作中，无需重复点击')
  }

  if (status === 405 && location.hash.indexOf('#/login') < 0) {
    router.replace({
      path: '/login',
      query: { redirect: window.location.href },
    })
  }

  if (status === 401 && location.hash !== '#/auth') {
    router.replace('/auth')
  }

  return Promise.reject(result)
})

// 1. 接口返回417，不用调到首页，不做任何处理
// 2. 接口返回503，提示请在微信客户端打开链接
// 3. 接口返回401，当前页面重定向到微信授权页面（接口返回微信url），微信回调后端接口，后端接口重定向到登录页或首页
export const BASE_API_URL = `/${BASE_PROJECT}`
const { post, get } = http

export {
  http,
  post,
  get,
}

// 手动增加头, 用于测试环境，在不方便加入头信息的浏览器中做测试, 但谷歌一般是通过Modify Headers插件加入头。
export function addHeader (headers = {}) {
  Object.assign(http.defaults.headers, headers)
}
